const routerArr = [
    {
        path: '/dream',
        name: 'rallyCard',
        meta: { title:'燃梦集结卡会员权益领取',login:false },
        component: () => import(/* webpackChunkName: 'entiryCard' */ './page/card.vue'),
    },
    {
        path: '/flaunt',
        name: 'futureCard',
        meta: { title:'炫动未来卡会员权益领取',login:false },
        component: () => import(/* webpackChunkName: 'entiryCard' */ './page/card.vue'),
    },
    {
        path: '/entityCard/binding',
        name: 'entityCardBinding',
        meta: { title:'激活绑定卡',login:false },
        component: () => import(/* webpackChunkName: 'entiryCard' */ './page/binding.vue'),
    },
    {
        path: '/entityCard/careerPlanning',
        name: 'careerPlanning',
        meta: { title:'深度职业规划',login:false },
        component: () => import(/* webpackChunkName: 'entiryCard' */ './page/careerPlanning.vue'),
    },
    {
        path: '/entityCard/exchangeMembers',
        name: 'exchangeMembers',
        meta: { title:'生活娱乐',login:false },
        component: () => import(/* webpackChunkName: 'entiryCard' */ './page/exchangeMembers.vue'),
    },
    {
        path: '/entityCard/employmentPower',
        name: 'employmentPower',
        meta: { title:'无忧就业助力服务',login:false },
        component: () => import(/* webpackChunkName: 'entiryCard' */ './page/employmentPower.vue'),
    },
    {
        path: '/entityCard/InternetCelebrityIncubation',
        name: 'InternetCelebrityIncubation',
        meta: { title:'网红孵化营训练营',login:false },
        component: () => import(/* webpackChunkName: 'entiryCard' */ './page/InternetCelebrityIncubation.vue'),
    },
    {
      path: '/entityCard/appraisal',
      name: 'entityCardAppraisal',
      meta: { title:'职业测评',login:false },
      component: () => import(/* webpackChunkName: 'entiryCard' */ './page/appraisal.vue'),
    },
    {
        path: '/entityCard/rightsChange',
        name: 'entityCardRightsChange',
        meta: { title:'课程列表',login:false },
        component: () => import(/* webpackChunkName: 'entiryCard' */ './page/rightsChange.vue'),
    },
    {
        path: '/jieshao01',
        name: 'entityCardRightsJieshao1',
        meta: { title:'燃梦集结卡会员权益介绍',login:false },
        component: () => import(/* webpackChunkName: 'entiryCard' */ './page/jieshao01.vue'),
    },
    {
        path: '/jieshao02',
        name: 'entityCardRightsJieshao2',
        meta: { title:'炫动未来卡会员权益介绍',login:false },
        component: () => import(/* webpackChunkName: 'entiryCard' */ './page/jieshao02.vue'),
    },
    {
        path: '/jieshao03',
        name: 'entityCardRightsJieshao3',
        meta: { title:'燃梦集结卡会员权益介绍',login:false },
        component: () => import(/* webpackChunkName: 'entiryCard' */ './page/jieshao01.vue'),
    },
    {
        path: '/jieshao04',
        name: 'entityCardRightsJieshao4',
        meta: { title:'炫动未来卡会员权益介绍',login:false },
        component: () => import(/* webpackChunkName: 'entiryCard' */ './page/jieshao02.vue'),
    },
  ]
  export default routerArr 